export default "__VITE_PUBLIC_ASSET__a247deaf__"